/**
 * @generated SignedSource<<23b44674d958d34e5ec498c191e36e38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Nav_internalLinks$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DalMobileNav_internalLinks" | "DesktopNav_internalLinks">;
  readonly " $fragmentType": "Nav_internalLinks";
};
export type Nav_internalLinks$key = {
  readonly " $data"?: Nav_internalLinks$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav_internalLinks">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Nav_internalLinks",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DalMobileNav_internalLinks"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesktopNav_internalLinks"
    }
  ],
  "type": "NavBarLinks",
  "abstractKey": null
};

(node as any).hash = "0bf0882fa1f02cd44bb43104d3751d8b";

export default node;
